import React, { useState, useEffect } from "react";
import styles from "./CheckoutMobile.module.css";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { useNavigate } from "react-router-dom";
import backbutton from "../../assets/icons/backbutton.png";

import axios from "axios";

import logo from "../../assets/images/logo.png";
import FooterMobile from "../FooterMobile/FooterMobile";

const CheckoutMobile = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const { user } = useAuth();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();

  const location = useLocation();
  const { cartItems, totalPrice } = location.state || {
    cartItems: [],
    totalPrice: 0,
  };
  const [address, setAddress] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  // ERROR HANDELING
const [errors, setErrors] = useState({});

const validateForm = () => {
 const newErrors = {};
 if (!address.trim()) {
   newErrors.address = "address or Number is required";
 }
 if (!paymentMethod.trim()) {
   newErrors.paymentMethod = "Payment Method is required";
 }
 setErrors(newErrors);
 return Object.keys(newErrors).length === 0;
};
  const handlePlaceOrder = async () => {
    const isValid = validateForm();
    if (!isValid) return;
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      await axios.post(
        `${MAIN_URL}/api/invoice/createInvoice`,
        {
          user: user._id,
          address,
          paymentMethod,
          products: cartItems.map((item) => ({
            product: item.productId._id,
            productName: item.productId.productName,
            color: item.productId.color,
            imgUrl: item.productId.imgUrl,
          })),
          totalPrice,
        },
        config
      );

      await axios.delete(`${MAIN_URL}/api/cart/removeCart`, config);

      localStorage.removeItem("cartItems");
      localStorage.removeItem("totalPrice");
      navigate("/successpage");
    } catch (error) {
      console.log("Failed to create invoice. Please try again later.");
    }
  };

  useEffect(() => {
    if (cartItems.length > 0) {
      setSelectedProduct(cartItems[0]);
    }
  }, [cartItems]);

  return (
    <>
      <div className={styles.checkout_page}>
        <div className={styles.checkout_headContainer}>
          <img className={styles.header_image} src={logo} alt="logo " />
          <div className={styles.header_text}>Musicart</div>
        </div>
        <div className={styles.checkout_mainContainer}>
          {/* BACK BUTTON  */}
          <div className={styles.product_back_btn}>
            <NavLink to="/home">
              <button className={styles.back_btn}>
                <img src={backbutton} alt="backbutton" />
              </button>{" "}
            </NavLink>
          </div>

          {/* HEADING */}
          <div className={styles.main_heading}>
            <h2>Checkout</h2>
          </div>
          <div className={styles.container}>
            {/* LEFT SIDE */}
            <div className={styles.left_container}>
              {/* address details  */}
              <div className={styles.address_section}>
                <p className={styles.address_heading}>1. Delivery address</p>
                <div className={styles.address_details}>
                  <p className={styles.user_name}>{user.name}</p>
                  <textarea
                    className={styles.user_address}
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    cols="30"
                    rows="10"
                    placeholder="Enter your address"
                  ></textarea>
                   {errors.address && (
      <p className={styles.errors}>{errors.address}</p>
    )}
                </div>
              </div>
              <div className={styles.line1}></div>
              {/* payment details */}
              <div className={styles.payment_section}>
                <p className={styles.payment_heading}>2. Payment method</p>
                <div className={styles.payment_details}>
                  <select
                  className={styles.payment_mode}
                    value={paymentMethod}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  >
                    <option className={styles.options}
                    value="" disabled hidden>
                      Mode of payment
                    </option>
                    <option className={styles.options} value="Pay on Delivery">Pay on Delivery</option>
                    <option className={styles.options} value="UPI">UPI</option>
                    <option className={styles.options} value="Card">Card</option>
                  </select>
                  {errors.paymentMethod && (
      <p className={styles.errors}>{errors.paymentMethod}</p>
    )}
                </div>
              </div>
              <div className={styles.line2}></div>

              {/* review section  */}
              <div className={styles.review_section}>
                <p className={styles.review_heading}>
                  3. Review items and delivery
                </p>
                <div className={styles.review_details}>
                  {/* image section */}
                  <div className={styles.image_section}>
                    {cartItems.map((item, index) => (
                      <img
                        key={item.productId + index}
                        src={item.productId.imgUrl}
                        alt={item.productId.productName}
                        onClick={() => setSelectedProduct(item)}
                      />
                    ))}
                  </div>
                  {/* short details  */}
                  <div className={styles.short_details_section}>
                    <p className={styles.product_name}>
                      {selectedProduct
                        ? selectedProduct.productId.productName
                        : "No products in cart"}
                    </p>
                    <p className={styles.product_color}>
                      {selectedProduct
                        ? `Color: ${selectedProduct.productId.color}`
                        : ""}
                    </p>
                    <p className={styles.delivery_time}>
                      Estimated delivery : <br />
                      <span>Monday — FREE Standard Delivery</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.line3}></div>
            </div>

            {/* RIGHT SIDE  */}

            <div className={styles.right_container}>
              <div className={styles.order_summary}>
                <p className={styles.summary_heading}>Order Summary</p>
                <div className={styles.item_cost}>
                  <span>Items : </span>
                  <span>₹{totalPrice.toFixed(2)}</span>
                </div>
                <div className={styles.delivery_cost}>
                  <span>Delivery : </span>
                  <span>₹45.00</span>
                </div>
              </div>
              <div className={styles.line5}></div>

              <div className={styles.total_order_details}>
                <p className={styles.total_order_text}>Order Total : </p>
                <p className={styles.total_order_cost}>₹{totalPrice + 45}</p>
              </div>
              <button
                className={styles.right_container_btn}
                onClick={handlePlaceOrder}
              >
                Place your order
              </button>
            </div>
          </div>
        </div>

        <FooterMobile />
      </div>
    </>
  );
};

export default CheckoutMobile;
